import { useHasFeatureFlag } from '/src/hooks';

export function getRowColor(index) {
  switch (index) {
    case 0:
      return '#0086E6';
    case 1:
      return '#8ABC00';
    case 2:
      return '#EA5E5C';
    case 3:
      return '#82EDE4';
    case 4:
      return '#A85CD0';
    case 5:
      return '#FFD155';
    case 6:
      return '#BC2D4D';
    case 7:
      return '#99CFF5';
    case 8:
      return '#BA89F5';
    case 9:
      return '#003457';
    default:
      return 'rgba(75, 75, 75, 0.5)'; // #4B4B4B
  }
}

export function RowColor({ row, orderMeta }) {
  const hasOverTime = useHasFeatureFlag('analytics-over-time');

  const key = row.original.code ? row.original.code : `${row.original.domain || ''}${row.original.name}`;
  const order = orderMeta?.[key] ?? { index: -1, color: getRowColor(-1) };

  const rowColor = hasOverTime ? order.color : 'transparent';

  return <span style={{ background: rowColor }} className="block w-[3px] h-full flex-shrink-0" />;
}
